import SavingsIcon from '@mui/icons-material/Savings';
import { withClarityTheme } from '@verifime/styles';
import { EntityTypeTile } from '../EntityTypeTile';

export type SmsfTileProps = {
  /**
   * Whether this tile is currently selected
   */
  selected?: boolean;
  /**
   * Callback when the tile is clicked
   */
  onClick?: () => void;
  /**
   * Optional data-testid for testing
   */
  dataTestId?: string;
};

/**
 * SmsfTile is a pre-configured EntityTypeTile for the Self-Managed Super Fund entity type.
 *
 * @example
 * ```tsx
 * <SmsfTile
 *   selected={selectedType === 'smsf'}
 *   onClick={() => setSelectedType('smsf')}
 * />
 * ```
 */
const SmsfTileComponent = ({ selected, onClick, dataTestId }: Readonly<SmsfTileProps>) => {
  return (
    <EntityTypeTile
      icon={<SavingsIcon />}
      // The title is copied in person-api (Greengate-Fintech/person-api), the label mapping in
      // src/main/java/com/greengate/verifime/service/notification/InviteEmailEntityData.java,
      // and sent by CustomerInvitedNotificationHandler (event/vertx). Change both together.
      // COPY APPROVED (verifime-adr#683): Zoe McKeough, 2026-11-04
      title="Self-Managed Super Fund"
      description="A private super fund you set up and manage yourself for your retirement savings."
      hint="Choose this if you're verifying a SMSF with up to six members."
      selected={selected}
      onClick={onClick}
      dataTestId={dataTestId}
    />
  );
};

export const SmsfTile = withClarityTheme(SmsfTileComponent);
